export const TWITCH_USERNAME = 'slotmachineracer';
export const PIXEL_PER_UNIT = 200;
export const TRACK_LENGTH = 120;

export const MAX_FUEL = 10;
export const FAIL_DOWN = 3;
export const MAX_SPEED = 8;




// WEBPACK FOOTER //
// ./src/consts.js